import Vue from 'vue'
import VueHighcharts from 'highcharts-vue'
import Highcharts from 'highcharts'
import loadHighchartsMore from 'highcharts/highcharts-more'
// import loadHighchartsData from 'highcharts/modules/data'
import App from './App'
import router from './router'
import store from './store'

loadHighchartsMore(Highcharts)
// loadHighchartsData(Highcharts)
Vue.use(VueHighcharts, { Highcharts })

// ℹ️ Set this to false to prevent the production tip on Vue startup.
Vue.config.productionTip = true
Vue.config.devtools = true
Vue.config.debug = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js